// Design System types for styling
enum FieldTypes {
  TEXT = "text",
  SELECT = "select",
  SELECT_CUSTOM = "select_custom", //TODO remove when design system has styles defined for .hcs-select
  FILE_CUSTOM = "file_custom" //TODO remove when design system has styles defined for file upload
}

export default FieldTypes;